var _rect, _rect2, _path, _rect3, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path3, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.4,109a6.52,6.52,0,0,1,2.54-.26,10.1,10.1,0,0,1,2.46.2l-.06.06c0-.05,0-.08.06-.08s0,0,.07.08a.08.08,0,0,1,0,0h0a9.59,9.59,0,0,1-2.46.2A6.3,6.3,0,0,1,153.4,109Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,109a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4,109a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.4,109a12.15,12.15,0,0,1,5,0,6.11,6.11,0,0,1-2.5.26A6.11,6.11,0,0,1,123.4,109Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4,109a6.31,6.31,0,0,1,2.5-.26,6.31,6.31,0,0,1,2.5.26,6.11,6.11,0,0,1-2.5.26A6.11,6.11,0,0,1,113.4,109Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4,109a6.31,6.31,0,0,1,2.5-.26,6.31,6.31,0,0,1,2.5.26,6.11,6.11,0,0,1-2.5.26A6.11,6.11,0,0,1,103.4,109Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,105.87a6.31,6.31,0,0,1,.26,2.5c0,.21,0,.42,0,.64l-.25-.25c1.07,0,1.85.13,1.85.25s-.78.22-1.85.25a.23.23,0,0,1-.25-.23h0v-.64A6.11,6.11,0,0,1,96.55,105.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,95.87a6.31,6.31,0,0,1,.26,2.5,6.31,6.31,0,0,1-.26,2.5,6.11,6.11,0,0,1-.26-2.5A6.11,6.11,0,0,1,96.55,95.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,85.87a6.31,6.31,0,0,1,.26,2.5,6.31,6.31,0,0,1-.26,2.5,6.11,6.11,0,0,1-.26-2.5A6.11,6.11,0,0,1,96.55,85.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,75.87a6.31,6.31,0,0,1,.26,2.5,6.31,6.31,0,0,1-.26,2.5,6.11,6.11,0,0,1-.26-2.5A6.11,6.11,0,0,1,96.55,75.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,65.87a6.31,6.31,0,0,1,.26,2.5,6.31,6.31,0,0,1-.26,2.5,6.11,6.11,0,0,1-.26-2.5A6.11,6.11,0,0,1,96.55,65.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,55.87a6.31,6.31,0,0,1,.26,2.5,6.31,6.31,0,0,1-.26,2.5,6.11,6.11,0,0,1-.26-2.5A6.11,6.11,0,0,1,96.55,55.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51,55.83a6.31,6.31,0,0,1-2.5.26,6.31,6.31,0,0,1-2.5-.26,6.31,6.31,0,0,1,2.5-.26A6.31,6.31,0,0,1,106.51,55.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.51,55.83a6.31,6.31,0,0,1-2.5.26,6.31,6.31,0,0,1-2.5-.26,6.31,6.31,0,0,1,2.5-.26A6.31,6.31,0,0,1,116.51,55.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.51,55.83a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.51,55.83a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.51,55.83a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,55.83a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,63.93a6.31,6.31,0,0,1-.26-2.5,6.31,6.31,0,0,1,.26-2.5,6.11,6.11,0,0,1,.26,2.5A6.11,6.11,0,0,1,158.4,63.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,73.93a6.31,6.31,0,0,1-.26-2.5,6.31,6.31,0,0,1,.26-2.5,6.11,6.11,0,0,1,.26,2.5A6.11,6.11,0,0,1,158.4,73.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,83.93a6.31,6.31,0,0,1-.26-2.5,6.31,6.31,0,0,1,.26-2.5,6.11,6.11,0,0,1,.26,2.5A6.11,6.11,0,0,1,158.4,83.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,93.93a6.31,6.31,0,0,1-.26-2.5,6.31,6.31,0,0,1,.26-2.5,6.11,6.11,0,0,1,.26,2.5A6.11,6.11,0,0,1,158.4,93.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,103.93a6.31,6.31,0,0,1-.26-2.5,6.31,6.31,0,0,1,.26-2.5,6.11,6.11,0,0,1,.26,2.5A6.11,6.11,0,0,1,158.4,103.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53,59h-6.25V52.71h6.25Zm-5.25-1h4.25V53.71h-4.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,59H93.43V52.71h6.24Zm-5.24-1h4.24V53.71H94.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,112.6H93.43v-6.24h6.24Zm-5.24-1h4.24v-4.24H94.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.45,112.6h-6.24v-6.24h6.24Zm-5.24-1h4.24v-4.24h-4.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,214.58a21.9,21.9,0,0,1,4.72-.26H435l-.26.26a20,20,0,0,1,.26-4.45,20,20,0,0,1,.26,4.45.26.26,0,0,1-.26.26h-.28A21.16,21.16,0,0,1,430,214.58Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,214.58a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,214.58a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,214.58a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,214.58a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,214.58a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,209.93a6.11,6.11,0,0,1,.26,2.5,13.66,13.66,0,0,1-.13,2.15l-.13-.13c.23,0,.35.09.35.13s-.12.1-.35.13a.1.1,0,0,1-.12-.08v0a13.66,13.66,0,0,1-.13-2.15A6.31,6.31,0,0,1,374.63,209.93Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,199.93a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,189.93a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,179.93a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,169.93a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.41,162.7a6.11,6.11,0,0,1-2.5.26h-.28l.26-.26a5.14,5.14,0,0,1-.26,2.23,5.52,5.52,0,0,1-.26-2.23.26.26,0,0,1,.26-.26h.28A6.31,6.31,0,0,1,377.41,162.7Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.41,162.7a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.41,162.7a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.41,162.7a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.41,162.7a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.41,162.7a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,165.13a5.94,5.94,0,0,1-.26-2.43l.26.26h-.07a6.11,6.11,0,0,1-2.5-.26,6.31,6.31,0,0,1,2.5-.26H435a.26.26,0,0,1,.26.26h0A6.15,6.15,0,0,1,435,165.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,175.13a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,185.13a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,195.13a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,205.13a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,165.76h-6.11v-6.11H438Zm-5.11-1H437v-4.11h-4.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.69,165.76h-6.11v-6.11h6.11Zm-5.11-1h4.11v-4.11h-4.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.69,218.1h-6.11V212h6.11Zm-5.11-1h4.11V213h-4.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,218.1h-6.11V212H438Zm-5.11-1H437V213h-4.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.53,169.13h75s-7.38-8.32-17.12-8.32c-6.13,0-10.65,3.7-15.39.49-2.51-1.71-9.37-10.17-22.55-8.64S39.53,169.13,39.53,169.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.27,125.23h47.29S409.9,120,403.76,120c-3.86,0-6.71,2.33-9.7.31-1.59-1.08-5.92-6.42-14.23-5.45S367.27,125.23,367.27,125.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,82.65h50.52S243.5,77,236.94,77c-4.13,0-7.18,2.5-10.37.33-1.7-1.14-6.32-6.85-15.2-5.82S198,82.65,198,82.65Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391,184.91s-6.72-2.78-11.22,12.86-5.66,24.38-5.66,24.38-1.34,3.35-3.77,1.8-6.3-6.54-9.59-4.87-3.82,6-2,11.78,5.39,18.62,5.7,19.78,0,3-1.84,2.18-13.07-9.31-16.79-3.73,4,20.87,4.86,22.56.61,2.51-.15,3.12-4.27-2.62-7.57-4.91-7.52-4.37-9.4-1-.31,15.69,15.07,33.18l7.65,7.64,10.53-2.65c22.2-7.05,29.88-16.77,30-20.65s-4.55-4.28-8.55-4-8.68,1.21-9,.3-.08-1.72,1.49-2.75,16.11-10.11,15.8-16.81-14.34-5.21-16.31-5.47-1.31-2-.45-2.82,10.54-10,15.1-14,6.4-7.87,4.37-11.12-7.85-.85-10.72-.77-2.3-3.49-2.3-3.49,3.52-8.09,7.73-23.8-3.15-16.79-3.15-16.79",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.92,198.91a1.45,1.45,0,0,1-.06.34l-.24,1c-.22.89-.54,2.14-.95,3.73-.83,3.24-2.08,7.91-3.64,13.68-3.13,11.53-7.59,27.43-12.59,45S360,296,356.71,307.52l-3.81,13.63c-.44,1.59-.79,2.83-1,3.71-.12.4-.21.71-.29,1a1.41,1.41,0,0,1-.11.32,1.45,1.45,0,0,1,.06-.34l.24-1c.22-.89.54-2.14.95-3.73.83-3.24,2.08-7.91,3.64-13.68,3.13-11.53,7.59-27.43,12.59-45s9.47-33.4,12.73-44.92l3.81-13.63c.44-1.59.79-2.83,1-3.71.12-.4.21-.71.29-1A1.41,1.41,0,0,1,386.92,198.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.88,226.27a14.38,14.38,0,0,1,1.46,2.53c.82,1.6,1.89,3.84,3,6.33l2.83,6.42a21.33,21.33,0,0,1,1.12,2.69,14,14,0,0,1-1.45-2.53c-.81-1.61-1.85-3.86-3-6.36L367,229A19.59,19.59,0,0,1,365.88,226.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.32,244.24c-.07-.13,4.44-2.56,10.07-5.43s10.25-5.09,10.32-5-4.45,2.56-10.08,5.43S375.38,244.36,375.32,244.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.43,270.82a18.94,18.94,0,0,1,2.9-.65c1.79-.37,4.27-.86,7-1.5s5.16-1.27,6.93-1.75a19.53,19.53,0,0,1,2.89-.69,15,15,0,0,1-2.79,1c-1.74.56-4.18,1.27-6.91,1.9s-5.24,1.08-7.05,1.35A15.3,15.3,0,0,1,366.43,270.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,256.45a15.53,15.53,0,0,1,1.93,2c1.15,1.25,2.7,3,4.39,4.95s3.2,3.74,4.27,5.06a13.71,13.71,0,0,1,1.65,2.19,14.88,14.88,0,0,1-1.93-1.95c-1.14-1.25-2.69-3-4.39-5s-3.19-3.74-4.27-5.05A14.27,14.27,0,0,1,354.32,256.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.49,278.93a23,23,0,0,1,2.46,2.51c1.47,1.6,3.48,3.83,5.67,6.31s4.15,4.76,5.55,6.42a23.66,23.66,0,0,1,2.19,2.75,22.42,22.42,0,0,1-2.47-2.51c-1.47-1.6-3.47-3.83-5.66-6.31s-4.15-4.76-5.55-6.42A24.73,24.73,0,0,1,343.49,278.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.1,296.38a31,31,0,0,1,3.65-.93c2.26-.54,5.38-1.27,8.81-2.17s6.51-1.78,8.74-2.43l2.65-.75a4.36,4.36,0,0,1,1-.22,3.52,3.52,0,0,1-.93.41c-.6.23-1.49.55-2.6.91-2.21.74-5.28,1.68-8.72,2.58s-6.58,1.58-8.87,2c-1.14.22-2.07.38-2.71.48A3.65,3.65,0,0,1,359.1,296.38Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Building--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.21,405.51a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,405.51a6.11,6.11,0,0,1,2.5-.26,6.11,6.11,0,0,1,2.5.26,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.21,405.51a6.11,6.11,0,0,1,2.5-.26,6.11,6.11,0,0,1,2.5.26,6.31,6.31,0,0,1-2.5.26A6.31,6.31,0,0,1,112.21,405.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.21,405.51a6.11,6.11,0,0,1,2.5-.26,6.11,6.11,0,0,1,2.5.26,6.31,6.31,0,0,1-2.5.26A6.31,6.31,0,0,1,102.21,405.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.21,405.51a6.11,6.11,0,0,1,2.5-.26,6.11,6.11,0,0,1,2.5.26,6.31,6.31,0,0,1-2.5.26A6.31,6.31,0,0,1,92.21,405.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,395.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,385.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,375.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,365.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,355.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,345.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,335.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,325.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,315.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,305.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,295.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,285.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,275.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,265.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,255.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,245.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,235.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,225.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,215.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,205.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8,195.92a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.67,192.79a6.31,6.31,0,0,1-2.5.26,6.31,6.31,0,0,1-2.5-.26,6.31,6.31,0,0,1,2.5-.26A6.31,6.31,0,0,1,98.67,192.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.67,192.79a6.31,6.31,0,0,1-2.5.26,6.31,6.31,0,0,1-2.5-.26,6.31,6.31,0,0,1,2.5-.26A6.31,6.31,0,0,1,108.67,192.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.67,192.79a6.31,6.31,0,0,1-2.5.26,6.31,6.31,0,0,1-2.5-.26,6.31,6.31,0,0,1,2.5-.26A6.31,6.31,0,0,1,118.67,192.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.67,192.79a12.15,12.15,0,0,1-5,0,12.15,12.15,0,0,1,5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,194.25c-.11,0-.2-.6-.24-1.46l.24.24-1,0a6.31,6.31,0,0,1-2.5-.26,6.31,6.31,0,0,1,2.5-.26l1,0h0a.22.22,0,0,1,.21.24C137.4,193.65,137.31,194.25,137.21,194.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,204.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,214.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,224.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,234.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,244.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,254.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,264.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,274.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,284.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,294.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,304.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,314.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,324.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,334.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,344.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,354.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,364.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,374.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,384.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,394.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,404.25a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57,110.18c-.1.1-1-.61-1.95-1.59s-1.69-1.85-1.59-2,1,.61,2,1.59S305.67,110.08,305.57,110.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.64,117.25c-.1.1-1-.61-1.95-1.58s-1.69-1.85-1.58-2,1,.61,1.95,1.59S312.74,117.15,312.64,117.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.71,124.32c-.1.1-1-.61-1.95-1.58s-1.69-1.85-1.58-2,1,.61,1.95,1.59S319.81,124.22,319.71,124.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,132.45A6.31,6.31,0,0,1,324,130c0-.4,0-.78,0-1.11l.06.16c-.55-.61-.88-1.07-.81-1.14s.53.26,1.14.81a.17.17,0,0,1,.07.14v0c0,.33,0,.71,0,1.11A6.31,6.31,0,0,1,324.23,132.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,142.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,152.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,162.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,172.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,182.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,192.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,202.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,212.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,222.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,232.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,242.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,252.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,262.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,272.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,282.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,292.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,302.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,312.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,322.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,332.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,342.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,352.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,362.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,372.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,382.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,392.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,402.45a12.15,12.15,0,0,1,0-5,12.15,12.15,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,404.22a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,404.22a12.15,12.15,0,0,1,5,0,12.15,12.15,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,398.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,388.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,378.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,368.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,358.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,348.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,338.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,328.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,318.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,308.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,298.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,288.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,278.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,268.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,258.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,248.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,238.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,228.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,218.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,208.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,198.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,188.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,178.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,168.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,158.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,148.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,138.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,128.18a12.15,12.15,0,0,1,0,5,12.15,12.15,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,118.18a6.11,6.11,0,0,1,.26,2.5,6.11,6.11,0,0,1-.26,2.5,6.31,6.31,0,0,1-.26-2.5A6.31,6.31,0,0,1,302,118.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,108.18a6.11,6.11,0,0,1,.26,2.5,6.11,6.11,0,0,1-.26,2.5,6.31,6.31,0,0,1-.26-2.5A6.31,6.31,0,0,1,302,108.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,401.72a6.11,6.11,0,0,1,.26,2.5l-.26-.26h.51l.47,0,.79,0c.45.05.73.12.73.19s-.28.14-.73.18c-.23,0-.49.05-.79.06h-1l-.26-.26A6.31,6.31,0,0,1,232.23,401.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,391.75a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,381.78a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,371.81a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,361.84a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,351.88a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,341.91a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,331.94a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,322a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,312a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,302a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,292.06a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,282.09a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,272.13a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,262.16a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,252.19a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,242.22a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,232.25a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,222.28a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,212.31a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,202.35a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,192.38a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,182.41a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,172.44a12.05,12.05,0,0,1,0,5,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,162.47a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,152.5a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,142.53a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,132.56a12.1,12.1,0,0,1,0,5,12.1,12.1,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,122.6a6,6,0,0,1,.26,2.49,6,6,0,0,1-.26,2.49,12.05,12.05,0,0,1,0-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,112.63a6,6,0,0,1,.26,2.49,6,6,0,0,1-.26,2.49,6.24,6.24,0,0,1-.26-2.49A6.24,6.24,0,0,1,232.23,112.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,102.66a6,6,0,0,1,.26,2.49,6,6,0,0,1-.26,2.49,6.24,6.24,0,0,1-.26-2.49A6.24,6.24,0,0,1,232.23,102.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,92.69a6.08,6.08,0,0,1,.26,2.49,6,6,0,0,1-.26,2.49,6.24,6.24,0,0,1-.26-2.49A6.28,6.28,0,0,1,232.23,92.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,82.72a6.08,6.08,0,0,1,.26,2.49,6.11,6.11,0,0,1-.26,2.5,6.31,6.31,0,0,1-.26-2.5A6.28,6.28,0,0,1,232.23,82.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,72.75a6.11,6.11,0,0,1,.26,2.5,6.08,6.08,0,0,1-.26,2.49,6.28,6.28,0,0,1-.26-2.49A6.31,6.31,0,0,1,232.23,72.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,62.78a6.11,6.11,0,0,1,.26,2.5,6.08,6.08,0,0,1-.26,2.49,6.28,6.28,0,0,1-.26-2.49A6.31,6.31,0,0,1,232.23,62.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,52.82a6,6,0,0,1,.26,2.49,6.08,6.08,0,0,1-.26,2.49,6.28,6.28,0,0,1-.26-2.49A6.24,6.24,0,0,1,232.23,52.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.11,47c-.09.11-1-.54-2.05-1.45.87-.39.24-.11.43-.2h0v.48l0,.46c0,.3,0,.57-.05.8,0,.45-.11.73-.19.73s-.13-.28-.18-.73c0-.23,0-.5-.06-.8s0-.32,0-.46v-.48h0c.2-.09-.43.2.44-.19C233.44,46.05,234.21,46.87,234.11,47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.88,53.81a6.88,6.88,0,0,1-2.11-1.51c-1.08-.95-1.87-1.8-1.77-1.91a6.88,6.88,0,0,1,2.11,1.51C241.18,52.85,242,53.7,241.88,53.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65,60.63a6.68,6.68,0,0,1-2.11-1.51c-1.08-.94-1.87-1.79-1.77-1.9a6.68,6.68,0,0,1,2.11,1.51C249,59.67,249.75,60.52,249.65,60.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,67.46A6.88,6.88,0,0,1,255.31,66c-1.08-1-1.87-1.8-1.77-1.91a6.88,6.88,0,0,1,2.11,1.51C256.72,66.5,257.52,67.35,257.42,67.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.19,74.28a6.68,6.68,0,0,1-2.11-1.51c-1.08-.94-1.87-1.79-1.77-1.9a6.68,6.68,0,0,1,2.11,1.51C264.49,73.32,265.29,74.17,265.19,74.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,81.11a6.88,6.88,0,0,1-2.11-1.51c-1.08-.95-1.87-1.8-1.77-1.91a6.88,6.88,0,0,1,2.11,1.51C272.26,80.15,273.06,81,273,81.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.73,87.93a6.68,6.68,0,0,1-2.11-1.51c-1.08-.94-1.87-1.79-1.77-1.9A6.68,6.68,0,0,1,279,86C280,87,280.83,87.82,280.73,87.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,94.76a6.81,6.81,0,0,1-2.11-1.52c-1.08-.94-1.87-1.79-1.77-1.9a6.68,6.68,0,0,1,2.11,1.51C287.8,93.8,288.6,94.65,288.5,94.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.27,101.58a6.68,6.68,0,0,1-2.11-1.51c-1.08-.94-1.87-1.79-1.77-1.9a6.68,6.68,0,0,1,2.11,1.51C295.57,100.62,296.37,101.47,296.27,101.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,109.14a6.31,6.31,0,0,1-.26-2.5l.09.2h0l0,0,0,0-.1-.08-.18-.17-.35-.32-.56-.57c-.3-.33-.47-.56-.42-.62s.3.08.67.35c.18.13.4.29.63.48l.36.3.19.16.1.08.05,0,0,0h0c0,.08-.09-.2.08.19A6.11,6.11,0,0,1,302,109.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,119.06a6.21,6.21,0,0,1-.26-2.48,6.21,6.21,0,0,1,.26-2.48,6,6,0,0,1,.26,2.48A6,6,0,0,1,302,119.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,129a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,138.9a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,148.81a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,158.73a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,168.65a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,178.57a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,188.49a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,198.4a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,208.32a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,218.24a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,228.16a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,238.07a11.91,11.91,0,0,1,0-4.95,11.91,11.91,0,0,1,0,4.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,248a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,257.91a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,267.83a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,277.75a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,287.66a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,297.58a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,307.5a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,317.42a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,327.33a11.91,11.91,0,0,1,0-4.95,11.91,11.91,0,0,1,0,4.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,337.25a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,347.17a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,357.09a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,367a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,376.92a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,386.84a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,396.76a12,12,0,0,1,0-5,12,12,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.53,404.22A6.11,6.11,0,0,1,302,404l-.26.26h0v-.94c0-.3,0-.57.06-.8,0-.45.11-.73.18-.73s.14.28.19.73c0,.23,0,.5,0,.8s0,.32,0,.46v.48h0l-.26.26A6.31,6.31,0,0,1,299.53,404.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.56,404.22a12.1,12.1,0,0,1,5,0,12.1,12.1,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.6,404.22a12.05,12.05,0,0,1,5,0,12.05,12.05,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63,404.22a12.05,12.05,0,0,1,5,0,12.05,12.05,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.66,404.22a12.05,12.05,0,0,1,5,0,12.05,12.05,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.69,404.22a12.05,12.05,0,0,1,5,0,12.05,12.05,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.72,404.22a12.05,12.05,0,0,1,5,0,12.05,12.05,0,0,1-5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.95,
    y: 91.5,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 122.77,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 122.77,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 122.77,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 153.01,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 153.01,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 153.01,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 183.26,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 183.26,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 183.26,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 213.5,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 213.5,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 213.5,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 243.75,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 243.75,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 243.75,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 273.99,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 273.99,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 273.99,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 304.24,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 304.24,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 304.24,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 334.48,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 334.48,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 334.48,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.01,
    y: 364.72,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.33,
    y: 364.72,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.64,
    y: 364.72,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.63,
    y: 91.5,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.15,
    y: 134.33,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.15,
    y: 167.83,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.15,
    y: 201.32,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.15,
    y: 234.81,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.15,
    y: 268.3,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.15,
    y: 301.8,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.15,
    y: 335.29,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.15,
    y: 368.78,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.41,48.31h-6.35V42h6.35Zm-5.35-1h4.35V43h-4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.29,132h-6.12v-6.12h6.12Zm-5.12-1h4.12v-4.12h-4.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.77,
    y: 103.81,
    width: 5.57,
    height: 5.57,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.13 91.5 309.01 102.03 320.09 98.74 314.82 96.77 313.13 91.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 148.09,
    width: 97.06,
    height: 257.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.81,
    y: 148.09,
    width: 37.24,
    height: 257.82,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.81,
    y: 167.8,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.44,
    y: 167.8,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.81,
    y: 197.43,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.44,
    y: 197.43,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.81,
    y: 227.06,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.44,
    y: 227.06,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.81,
    y: 256.69,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.44,
    y: 256.69,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.81,
    y: 286.32,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.44,
    y: 286.32,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.81,
    y: 315.94,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.44,
    y: 315.94,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.81,
    y: 345.57,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.44,
    y: 345.57,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.81,
    y: 375.2,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.44,
    y: 375.2,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 168.44,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 195.73,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 226.28,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 255.49,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 284.69,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 313.89,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 343.1,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.75,
    y: 375.2,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.54,
    y: 146.47,
    width: 110.35,
    height: 3.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.15,
    y: 128.33,
    width: 39.28,
    height: 19.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.15,
    y: 128.33,
    width: 20.66,
    height: 18.14,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,189.46c0,.14-13.39.26-29.9.26S140,189.6,140,189.46s13.39-.26,29.91-.26S199.81,189.32,199.81,189.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,219.19c0,.15-13.39.27-29.9.27s-29.91-.12-29.91-.27,13.39-.26,29.91-.26S199.81,219.05,199.81,219.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,249.29c0,.14-13.39.26-29.9.26s-29.91-.12-29.91-.26,13.39-.26,29.91-.26S199.81,249.14,199.81,249.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,279.16c0,.15-13.39.26-29.9.26s-29.91-.11-29.91-.26,13.39-.26,29.91-.26S199.81,279,199.81,279.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,308.61c0,.14-13.39.26-29.9.26s-29.91-.12-29.91-.26,13.39-.26,29.91-.26S199.81,308.47,199.81,308.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,337.26c0,.14-13.39.26-29.9.26S140,337.4,140,337.26s13.39-.26,29.91-.26S199.81,337.11,199.81,337.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,369c0,.14-13.39.26-29.9.26S140,369.15,140,369s13.39-.26,29.91-.26S199.81,368.86,199.81,369Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.63,150.68c0,.15-8,.26-17.81.26s-17.81-.11-17.81-.26,8-.26,17.81-.26S236.63,150.54,236.63,150.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.63,189.46c0,.14-8,.26-17.81.26S201,189.6,201,189.46s8-.26,17.81-.26S236.63,189.32,236.63,189.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.63,219.19c0,.15-8,.27-17.81.27s-17.81-.12-17.81-.27,8-.26,17.81-.26S236.63,219.05,236.63,219.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.63,248.93c0,.14-8,.26-17.81.26s-17.81-.12-17.81-.26,8-.26,17.81-.26S236.63,248.78,236.63,248.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.24,279.16c0,.15-8,.26-17.8.26s-17.81-.11-17.81-.26,8-.26,17.81-.26S236.24,279,236.24,279.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.24,308.61c0,.14-8,.26-17.8.26s-17.81-.12-17.81-.26,8-.26,17.81-.26S236.24,308.47,236.24,308.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.24,338.06c0,.14-8,.26-17.8.26s-17.81-.12-17.81-.26,8-.26,17.81-.26S236.24,337.91,236.24,338.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.24,369c0,.14-8,.26-17.8.26s-17.81-.12-17.81-.26,8-.26,17.81-.26S236.24,368.86,236.24,369Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.39,
    y: 311.26,
    width: 71.93,
    height: 94.88,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.39,
    y: 311.26,
    width: 71.93,
    height: 94.88,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.6,
    y: 311.26,
    width: 33.73,
    height: 94.88,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.6,
    y: 311.26,
    width: 33.73,
    height: 94.88,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.48,
    y: 324.11,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.48,
    y: 385.61,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6,346c0,.14-8.56.26-19.1.26s-19.11-.12-19.11-.26,8.55-.26,19.11-.26S150.6,345.84,150.6,346Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.48,
    y: 355.09,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6,377c0,.14-8.56.26-19.1.26s-19.11-.12-19.11-.26,8.55-.26,19.11-.26S150.6,376.83,150.6,377Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.48,
    y: 324.11,
    width: 6.47,
    height: 15.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 127.48,
    y: 385.61,
    width: 6.47,
    height: 15.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.6,346c0,.14-8.56.26-19.1.26s-19.11-.12-19.11-.26,8.55-.26,19.11-.26S150.6,345.84,150.6,346Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 127.48,
    y: 355.09,
    width: 6.47,
    height: 15.71
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.6,377c0,.14-8.56.26-19.1.26s-19.11-.12-19.11-.26,8.55-.26,19.11-.26S150.6,376.83,150.6,377Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 324.11,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.79,
    y: 324.11,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 353.92,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.79,
    y: 353.92,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 383.74,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.79,
    y: 383.74,
    width: 6.47,
    height: 15.71,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 324.11,
    width: 6.47,
    height: 15.71
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 171.79,
    y: 324.11,
    width: 6.47,
    height: 15.71
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 353.92,
    width: 6.47,
    height: 15.71
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 171.79,
    y: 353.92,
    width: 6.47,
    height: 15.71
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 383.74,
    width: 6.47,
    height: 15.71
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 171.79,
    y: 383.74,
    width: 6.47,
    height: 15.71
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 106.99,
    y: 307.96,
    width: 82.75,
    height: 3.42,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.99,
    y: 307.96,
    width: 82.75,
    height: 3.42,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.83,311.7c0,.15-16.08.26-35.91.26S113,311.85,113,311.7s16.08-.26,35.91-.26S184.83,311.56,184.83,311.7Z",
    style: {
      fill: "#06EB83"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.83,311.7c0,.15-16.08.26-35.91.26S113,311.85,113,311.7s16.08-.26,35.91-.26S184.83,311.56,184.83,311.7Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 223.47,
    y: 268.19,
    width: 75.66,
    height: 137.32,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.47,
    y: 268.19,
    width: 75.66,
    height: 137.32,
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.76,
    y: 268.19,
    width: 21.37,
    height: 137.32,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.76,
    y: 268.19,
    width: 21.37,
    height: 137.32,
    style: {
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.94,
    y: 285.91,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 285.91,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.94,
    y: 314.64,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 314.64,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.94,
    y: 343.37,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 343.37,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.94,
    y: 374.8,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 375.56,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 237.94,
    y: 285.91,
    width: 7.38,
    height: 15.55
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 285.91,
    width: 7.38,
    height: 15.55
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 237.94,
    y: 314.64,
    width: 7.38,
    height: 15.56
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 314.64,
    width: 7.38,
    height: 15.56
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 237.94,
    y: 343.37,
    width: 7.38,
    height: 15.56
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 343.37,
    width: 7.38,
    height: 15.56
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 237.94,
    y: 374.8,
    width: 7.38,
    height: 15.55
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 258.45,
    y: 375.56,
    width: 7.38,
    height: 15.55
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,368.52c0,.14-12,.26-26.81.26s-26.81-.12-26.81-.26,12-.26,26.81-.26S277.83,368.37,277.83,368.52Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,337.65c0,.15-12,.26-26.81.26s-26.81-.11-26.81-.26,12-.26,26.81-.26S277.83,337.51,277.83,337.65Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.83,308c0,.14-12,.26-26.81.26s-26.81-.12-26.81-.26,12-.26,26.81-.26S277.83,307.81,277.83,308Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.83,368.52c0,.14-12,.26-26.81.26s-26.81-.12-26.81-.26,12-.26,26.81-.26S277.83,368.37,277.83,368.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M277.83,337.65c0,.15-12,.26-26.81.26s-26.81-.11-26.81-.26,12-.26,26.81-.26S277.83,337.51,277.83,337.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M277.83,308c0,.14-12,.26-26.81.26s-26.81-.12-26.81-.26,12-.26,26.81-.26S277.83,307.81,277.83,308Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 285.12,
    y: 286.34,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.12,
    y: 315.93,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.12,
    y: 345.53,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.12,
    y: 375.13,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.28,
    y: 177.04,
    width: 87.15,
    height: 228.12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.87,
    y: 178.06,
    width: 43.58,
    height: 228.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.23,
    y: 149.93,
    width: 30.78,
    height: 27.12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.67,
    y: 149.93,
    width: 7.33,
    height: 27.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.44,
    y: 188.87,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,210.53c0,.14-9.76.26-21.79.26s-21.79-.12-21.79-.26,9.76-.26,21.79-.26S355.81,210.39,355.81,210.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.44,
    y: 219.75,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,241.41c0,.15-9.76.26-21.79.26s-21.79-.11-21.79-.26,9.76-.26,21.79-.26S355.81,241.27,355.81,241.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.44,
    y: 251.57,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,273.23c0,.14-9.76.26-21.79.26s-21.79-.12-21.79-.26S322,273,334,273,355.81,273.08,355.81,273.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.44,
    y: 283.38,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,305c0,.15-9.76.26-21.79.26s-21.79-.11-21.79-.26,9.76-.26,21.79-.26S355.81,304.9,355.81,305Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.44,
    y: 314.29,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,336c0,.14-9.76.26-21.79.26s-21.79-.12-21.79-.26,9.76-.26,21.79-.26S355.81,335.8,355.81,336Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.44,
    y: 345.32,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.44,
    y: 376.75,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,367c0,.14-9.76.26-21.79.26s-21.79-.12-21.79-.26,9.76-.26,21.79-.26S355.81,366.83,355.81,367Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.02,
    y: 175.46,
    width: 96.97,
    height: 1.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 188.87,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.86,210.53c0,.14-9.76.26-21.79.26s-21.79-.12-21.79-.26,9.75-.26,21.79-.26S311.86,210.39,311.86,210.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 220.22,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.86,241.88c0,.15-9.76.26-21.79.26s-21.79-.11-21.79-.26,9.75-.26,21.79-.26S311.86,241.74,311.86,241.88Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 251.58,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.86,273.24c0,.14-9.76.26-21.79.26s-21.79-.12-21.79-.26S278,273,290.07,273,311.86,273.09,311.86,273.24Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 282.93,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.86,304.59c0,.15-9.76.26-21.79.26s-21.79-.11-21.79-.26,9.75-.26,21.79-.26S311.86,304.45,311.86,304.59Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 314.29,
    width: 7.38,
    height: 15.55,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.86,336c0,.14-9.76.26-21.79.26s-21.79-.12-21.79-.26,9.75-.26,21.79-.26S311.86,335.8,311.86,336Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 345.64,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.86,367.3c0,.15-9.76.26-21.79.26s-21.79-.11-21.79-.26S278,367,290.07,367,311.86,367.16,311.86,367.3Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.48,
    y: 377,
    width: 7.38,
    height: 15.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.38,
    y: 312,
    width: 71.21,
    height: 93.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.2,
    y: 312,
    width: 33.39,
    height: 93.92,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.31,
    y: 324.71,
    width: 6.4,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.31,
    y: 385.59,
    width: 6.4,
    height: 15.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.2,346.37c0,.15-8.47.26-18.91.26s-18.91-.11-18.91-.26,8.46-.26,18.91-.26S382.2,346.23,382.2,346.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.31,
    y: 355.38,
    width: 6.4,
    height: 15.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.2,377c0,.15-8.47.26-18.91.26s-18.91-.11-18.91-.26,8.46-.26,18.91-.26S382.2,376.9,382.2,377Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.29,
    y: 324.71,
    width: 6.4,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.18,
    y: 324.71,
    width: 6.4,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.29,
    y: 354.23,
    width: 6.4,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.18,
    y: 354.23,
    width: 6.4,
    height: 15.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.29,
    y: 383.74,
    width: 6.4,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.18,
    y: 383.74,
    width: 6.4,
    height: 15.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.02,
    y: 308.73,
    width: 81.91,
    height: 3.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.08,312.43c0,.15-15.92.26-35.54.26s-35.55-.11-35.55-.26,15.91-.26,35.55-.26S416.08,312.29,416.08,312.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85,194.85H88.74v-6.12h6.11Zm-5.11-1h4.11v-4.12H89.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.24,
    y: 266.37,
    width: 5.11,
    height: 5.11,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.55,405.91c0,.15-85.85.27-191.71.27s-191.74-.12-191.74-.27,85.83-.26,191.74-.26S451.55,405.77,451.55,405.91Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.e2afbdca612abb8393f4e2e97ff1c481.svg";
export { ForwardRef as ReactComponent };